import appointmentDialogReducer from './appointmentDialogReducer';

export default appointmentDialogReducer;